import { Outlet } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Header } from "./Header";
import { AlertBanner } from "@/components/AlertBanner";
import { useOrgs } from "@/lib/orgs";

export function AppShell() {
  const orgs = useOrgs();
  return (
    <TooltipProvider delayDuration={300}>
      <div className="min-h-screen flex flex-col">
        <AlertBanner />
        <Header orgs={orgs.data} />
        <main className="flex-1">
          <Outlet />
        </main>
        <footer className="border-t border-border-muted py-4 px-4 text-2xs text-subtle-foreground flex items-center justify-between">
          <span>
            openfront <span className="font-mono">v0.0.0</span>
          </span>
          <span className="flex items-center gap-3">
            <a className="hover:text-foreground transition-colors" href="https://github.com/kmhari/openfrontend">GitHub</a>
            <a className="hover:text-foreground transition-colors" href="/docs">Docs</a>
            <a className="hover:text-foreground transition-colors" href="/_health">Status</a>
          </span>
        </footer>
      </div>
    </TooltipProvider>
  );
}
